import { Box, Flex, Stack } from '@chakra-ui/react';
import Card from '@components/atoms/Card';
import Button, { ButtonVariants } from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

function SignUpForMedicareCard({
  title,
  description = '',
  primaryButtonLabel = '',
  primaryButtonId,
  primaryHref,
  secondaryButtonLabel = '',
  secondaryButtonId,
  secondaryHref,
}) {
  return (
    <Card>
      <Stack align="left" textAlign="left">
        <Stack p={[6, 8]} gap={4}>
          <Box>
            <Header as="h4" mb={2}>
              {title}
            </Header>
            <Body1 maxW="600px">{description}</Body1>
          </Box>
          <Flex direction={['column', 'column', 'row']} align={['left', 'left', 'center']} gap={4}>
            <Button id={primaryButtonId} href={primaryHref} target="_blank">
              {primaryButtonLabel}
            </Button>
            <Button id={secondaryButtonId} href={secondaryHref} variant={ButtonVariants.secondary} whiteSpace="prewrap">
              {secondaryButtonLabel}
            </Button>
          </Flex>
        </Stack>
      </Stack>
    </Card>
  );
}

export default SignUpForMedicareCard;
